<template>
  <router-view />
</template>

<script>
export default {
  name: "ServiceConfigurations",
};
</script>

<style lang="scss" scoped></style>
